import '../lib/globals/babel'
import '../lib/chunk_load_handler'

import loadPolyfills from '../lib/polyfills'
import { platform } from '@polleverywhere/slideware-bindings/lib/platform'
import '../lib/init.scss'

async function bootApp () {
  const startAppLoader = (await import(/* webpackChunkName: "start-app" */ './util/startApp'))
  const useNewCustomsAuth = ['windows', 'mac', 'google'].includes(platform())

  const opts = {
    role: 'slideware',
    appName: 'Poll Everywhere Presenter',
    mode: 'integration',
    outOfBandAuth: useNewCustomsAuth,
    extraDomainAuth: useNewCustomsAuth
  }

  if (platform() === 'google') {
    opts.usePopupAuthCodeFlow = true
  }

  const appendTo = document.getElementById('main-content') ? '#main-content' : 'body'
  startAppLoader.startApp(opts, appendTo)
}

loadPolyfills().then(async () => {
  if (navigator.onLine) {
    bootApp()
  } else {
    const offlineMessage = (await import(/* webpackChunkName: 'offline-message' */ './util/offlineMessage')).offlineMessage
    offlineMessage('Poll Everywhere Presenter')
  }
})
